angular.module('bmsApp.settings').controller('UserRoleIndexCtrl',
	function ($scope, ngTableParams, $state, UserRoleSvc) {

		$scope.loading = true;

		$scope.tableParams = new ngTableParams(angular.extend({
			page: 1, // show first page
			count: $scope.config.table.params.count, // count per page
			sorting: {
				//role: 'asc' // initial sorting
			},
			filter: {
				//Search: $scope.filterText
				UserType:''
			},
		}), {
			total: 0, // length of data
			counts: $scope.config.table.settings.counts, // available page counts
			getData: function ($defer, params) {
				UserRoleSvc.index(params.$params)
					.then(function (response) {
						params.total(response.data.role_filtered_count);
						$scope.loading = false;
						$scope.updating = false;
						$defer.resolve(response.data.role_collection);
					});
			}
		});

		$scope.filterChanged = function () {
			$scope.updating = true;
			$scope.tableParams.$params.filter.Search = $scope.filterText;
		};

		$scope.rowClicked = function(user){
			$state.go('main.settings.userRoles.edit', {id: user.id});
		}

	});